import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router';

//MaterialUI Imports
import {
    Alert,
    Autocomplete,
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Snackbar,
    Stack,
    TextField,
    Tooltip,
    Typography,
    CardHeader,
    InputLabel,
    Card,
    CardContent,
    FormControl,
    Select,
    MenuItem
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MainCard from 'ui-component/cards/MainCard';

//icon imports
import PaymentsIcon from '@mui/icons-material/Payments';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FunctionsIcon from '@mui/icons-material/Functions';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

//services imports
import useEmployeeService from 'services/useEmployeeService';
import useGCSalarySlabItemsService from 'services/useGCSalarySlabItemsService';
import useGCGroupIncentivesService from 'services/useGCGroupIncentivesService';
import useGCSalarySlabsService from 'services/useGCSalarySlabsService';

//project imports
import { roles } from 'store/constant';
import { LoadingButton } from '@mui/lab';
import useGLSalarySlabsService from 'services/useGLSalarySlabsService';
import useGLSalarySlabItemsService from 'services/useGLSalarySlabItemsService';
import useGLGroupIncentivesService from 'services/useGLGroupIncentivesService';
import GLCard from './GLCard';

//third pary imports

const GLSalarySheets = (props) => {
    const { selectedRole, selectedLocation, selectedMonth, selectedYear } = props;
    const theme = useTheme();
    const navigate = useNavigate();

    //states
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState();
    const [glSalarySlabDetails, setGLSalarySlabDetails] = useState();
    const [glFiledExpensesDetails, setGLFiledExpensesDetails] = useState();
    const [glGroupIncentiveDetails, setGLGroupIncentiveDetails] = useState();

    //services
    const { getEmployees } = useEmployeeService();
    const { getGLSalarySlab } = useGLSalarySlabsService();
    const { getGLSalarySlabItems } = useGLSalarySlabItemsService();
    const { getGLGroupIncentives } = useGLGroupIncentivesService();

    //handlers
    const handleGetEmployees = () => {
        getEmployees(selectedRole, selectedLocation, 0, 100000)
            .then((response) => {
                if (response.status == 200) {
                    setEmployees(response.data.users);
                } else {
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleGetSalarySlabs = () => {
        getGLSalarySlab()
            .then((response) => {
                if (response.status == 200) {
                    if (response.data.list.length > 0) {
                        setGLSalarySlabDetails(response.data.list[0]);
                    }
                } else {
                    console.log(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleGetFieldExpenses = () => {
        getGLSalarySlabItems(glSalarySlabDetails.id)
            .then((response) => {
                if (response.status == 200) {
                    setGLFiledExpensesDetails(response.data.list);
                } else {
                    console.log(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleGetGroupIncentives = () => {
        getGLGroupIncentives(glSalarySlabDetails.id)
            .then((response) => {
                if (response.status == 200) {
                    setGLGroupIncentiveDetails(response.data.list);
                } else {
                    console.log(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    //use effects
    useEffect(() => {
        handleGetEmployees();
        handleGetSalarySlabs();
    }, [selectedRole, selectedLocation]);

    useEffect(() => {
        if (glSalarySlabDetails) {
            handleGetFieldExpenses();
        }
    }, [glSalarySlabDetails]);

    useEffect(() => {
        if (glSalarySlabDetails) {
            handleGetGroupIncentives();
        }
    }, [glSalarySlabDetails]);

    return (
        <Box>
            <Grid container spacing={2}>
                {employees ? (
                    <>
                        {employees.map((employee, index) => {
                            return (
                                <Grid item xs={12} md={6} key={index}>
                                    <GLCard
                                        employee={employee}
                                        glSalarySlabDetails={glSalarySlabDetails}
                                        glFiledExpensesDetails={glFiledExpensesDetails}
                                        glGroupIncentiveDetails={glGroupIncentiveDetails}
                                        onRefresh={() => {
                                            handleGetSalarySlabs();
                                            handleGetFieldExpenses();
                                            handleGetGroupIncentives();
                                        }}
                                        location={selectedLocation}
                                        month={selectedMonth}
                                        year={selectedYear}
                                    />
                                </Grid>
                            );
                        })}
                    </>
                ) : null}
            </Grid>
        </Box>
    );
};

export default GLSalarySheets;
